import { useEffect } from "react";
import UserService from "rc-app/services/UserService";
import { promptUserGeo } from "rc-app/utils/userGeoCache";
import { useGlobalSessionReaper } from "rc-app/hooks/useGlobalSessionReaper";
import { isPublicPath } from "rc-app/utils/publicRoutes";

const RenderOnAuthenticated = ({ children }) => {
  const loggedIn = UserService.isLoggedIn();

  // Attempt 1 of the location capture flow — fire 1.5s after auth so the
  // page renders first and the permission prompt doesn't slam in cold.
  // promptUserGeo is idempotent: returns the cached grant on subsequent
  // mounts, and respects the 2-strike + 7-day cool-down internally.
  useEffect(() => {
    if (!loggedIn) return undefined;
    const t = setTimeout(() => {
      void promptUserGeo();
    }, 1500);
    return () => clearTimeout(t);
  }, [loggedIn]);

  // Periodic VR session idle-reaper. Catches sessions left "Active" when
  // the user navigates away from the tour without closing the tab (which
  // unmounts useMatterportAnalytics and kills its per-tour idle timer).
  useGlobalSessionReaper(loggedIn);

  if (window.location.pathname === "/reset-password") return null;

  // ── Public-route bypass ──
  // Anonymous buyers reach share links, guided-tour doors and website embeds
  // with no Keycloak session, so those routes must render without one. The
  // list is shared with RenderOnAnonymous — the two gates have to agree, and
  // utils/publicRoutes records what breaks when they don't.
  if (isPublicPath(window.location.pathname, window.location.search)) {
    return children;
  }

  if (loggedIn) return children;
  return null;
};

export default RenderOnAuthenticated;
